module.exports = __webpack_public_path__ + "static/media/archive.7c5a3a6d.png";